import styled, { css, useTheme } from "styled-components";
import { AuthoryColorSchemeProps, CustomDarkShade, getFontColor } from "./FontSetUtilities";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";

import type { JSX } from "react";

export const SVGThemableStyle = css<AuthoryColorSchemeProps>`
    svg {
        opacity: 0.6;

        path {
            stroke: ${({ $customDarkShade, theme }) => {
                return getFontColor(theme.customization.backgroundColor, AuthoryColorSchemes.userTheme, $customDarkShade);
            }};
        }
    }
`;

export const SVGThemableHover = css<AuthoryColorSchemeProps>`
    &:focus,
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

const IconDotWrapper = styled.div`
    position: absolute;
    top: -6px;
    right: -3px;
`;

const IconFilterWraper = styled.div<AuthoryColorSchemeProps>`
    position: relative;

    ${SVGThemableStyle}
`;

const ActiveDot = () => {
    const theme = useTheme();

    return (
        <IconDotWrapper>
            <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="4.5" fill={theme.customization.accentcolour} stroke="#fff" />
            </svg>
        </IconDotWrapper>
    );
};

interface ActiveIconToggleProps {
    active: boolean;
    icon: JSX.Element;
}

export const ActiveIconToggle = ({ active, icon }: ActiveIconToggleProps) => (
    <IconFilterWraper $customDarkShade={CustomDarkShade.Grey35}>
        {icon}
        {active && <ActiveDot />}
    </IconFilterWraper>
);
